<!-- Loading bar -->
<ngx-loading-bar [includeSpinner]="false" color="#858cf3" height="4px"></ngx-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation class="dark  z-[10000] text-white print:hidden" [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'" [navigation]="navigation.futuristic" [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationHeader>
        <!-- Logo -->
        <div class="h-20 items-center p-6 mt-2 text-md">
            <a href="/home">
                <img class="w-48 mx-auto" src="images/logo/logo-text-on-dark.svg" />
            </a>
        </div>
    </ng-container>
    <!-- Navigation footer hook -->
    <ng-container fuseVerticalNavigationFooter>

    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-black-900 dark:shadow-none md:px-6 print:hidden">
        <!-- Navigation toggle button -->
        <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
            <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
        </button>
        <!-- Components -->
        <div class="flex-grow text-center opacity-100 dark:text-primary-400 bold font-semibold tracking-wide text-lg">
            <span>AGNEXUS' MARKET INTELLIGENCE PLATFORM</span>
        </div>
        <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
            <themeswitch></themeswitch>
            <user></user>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts> -->
            <!-- <messages></messages>
            <notifications></notifications> -->
            <!-- <button
                class="lg:hidden"
                mat-icon-button
                (click)="quickChat.toggle()"
            >
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button> -->
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
        <router-outlet></router-outlet>
        }
    </div>

    <!-- Footer -->
    <div class="bg-card relative z-49 w-full h-14 border-t px-4 dark:bg-black-900 md:px-6 print:hidden">
        <!-- Flex container to center the version text -->
        <div class="relative flex items-center justify-center h-full">
            <!-- Absolutely positioned left text -->
            <span class="absolute left-4 top-1/2 -translate-y-1/2 text-secondary font-medium">
                Copyright AgNexus | All Rights Reserved &copy; {{ currentYear }}
            </span>

            <!-- Perfectly centered version text -->
            <span class="text-secondary font-medium">
                Platform Version: 2.0.0
            </span>
        </div>

        <!-- Fixed position feedback button (no effect on centering) -->
        <!-- <div class="fixed bottom-4 right-4 -my-1.5 z-99999">
            <button (click)="toggleDropdown()" id="feedbackButton"
                class="inline-flex justify-center w-full rounded-md border shadow-sm px-4 py-2 text-sm font-medium"
                aria-expanded="true" aria-haspopup="true" [ngClass]="{
            'bg-white text-black border-gray-300': currentTheme === 'light',
            'bg-gray-800 text-white border-indigo-300': currentTheme === 'dark'
        }">
                Want to share your feedback?
            </button>

            Dropdown Pane
            <div id="feedbackDropdown"
                class="origin-bottom-right absolute right-0 bottom-12 w-56 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none hidden z-[10000]"
                [ngClass]="{
            'bg-white text-black border-gray-300': currentTheme === 'light',
            'bg-gray-800 text-white border-indigo-300': currentTheme === 'dark'
        }">
                <div class="py-1">
                    <div class="flex items-center flex-col px-4 py-2" style="z-index: 999999999;">
                        <img type="image/png" src="images/QRCodeFeedback.png" alt="Feedback" />
                        <br />
                        <a href="https://forms.gle/BxN6j9pnQRDidJ9w8" target="_blank"
                            class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700">
                            Link URL
                        </a>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
